/**
 * Imports only the extensions
 *
 */

import './themes/theme-ui/extensions'
